import React from 'react';
import './tailwind/built.css';
import {connect} from 'react-redux';
// import PublicView from './view/public/index'
import MainView from './view/mainView'
import {
  BrowserRouter as Router,
  Switch
} from "react-router-dom";
import { Route } from "react-router"; 
import {PermissionProvider} from './contexts/permissionContext'
import Landing from 'view/public/landing/landing';
import Footer from 'view/common/footer';
import ContactUsForm from 'view/public/landing/contactUsForm';
import { NotificationContainer } from 'view/common/notification';

// import tokenStore from './helpers/tokenStore'


require('dotenv').config()

const App = (props) => {

  return (
      <React.Fragment>
        <PermissionProvider value={props.permissions}>
          <Router>
            <NotificationContainer/>
            <Switch>
              
              <Route exact path="/" component={Landing} />
              <Route exact path="/contactUs" component={ContactUsForm} />
              
              <Route component={MainView} />
            </Switch>
          </Router>
          
        </PermissionProvider>
        <Footer/>
      </React.Fragment>
  );
}

const mapStateToProps = state => ({
    permissions:state.authentication.permissions,
})


export default connect(mapStateToProps, {})(App);